module.exports = __webpack_public_path__ + "static/media/activity-exercise-football-svgrepo-com.e73ef0bb.svg";